import { AutocompleteMulti, getRenderTagsForAutocompleteMulti, Select, SelectItem, TextInput } from '@uplift/ui-v2';
import { useL10n } from '@uplift/hooks';
import { useSettingsStyles } from '../../../styles';
import { MentalHealthRole } from '@uplift/api';
import { Typography } from '@mui/material';

export type NameFormProps = {
  mentalHealthRoles: MentalHealthRole[];
};

export const NameForm: React.VFC<NameFormProps> = ({ mentalHealthRoles }) => {
  const { classes } = useSettingsStyles();
  const l10n = useL10n();

  const prefixOptions = mentalHealthRoles?.filter(i => i.prefix).map((item) => {
    return ({
      id: item.id,
      label: item.prefix
    });
  }) ?? [];

  const suffixOptions = mentalHealthRoles?.filter(i => i.suffix).map((item) => {
    return ({
      id: item.id,
      label: item.suffix
    });
  }) ?? [];

  return (
    <div className={classes.formGroup}>
      <div className={classes.maxWidth120}>
        <Select
          label={l10n.accountSettings.isOptional(l10n.providerSettings.prefix)}
          name="prefix"

        >
          {prefixOptions.map((item) => (
            <SelectItem key={item.id} value={item.label}>
              {item.label}
            </SelectItem>
          ))}
          <SelectItem value={null}>
            <Typography component="i" color="textSecondary">{l10n.general.none}</Typography>
          </SelectItem>
        </Select>
      </div>
      <TextInput
        label={l10n.providerSettings.legalName}
        name="legalName"
        fullWidth
        disabled
        helperText={l10n.providerSettings.needToChangeEmail}
        inputClasses={{
          input: classes.disabledTextInput
        }}
      />
      <AutocompleteMulti
        label={l10n.accountSettings.isOptional(l10n.providerSettings.suffix)}
        name="mentalHealthRoleSuffixes"
        options={suffixOptions}
        extractId
        getOptionLabel={opt => opt?.label}
        renderTags={getRenderTagsForAutocompleteMulti(opt => opt?.label)}
      />
      <TextInput
        label={l10n.accountSettings.isOptional(l10n.accountSettings.profile.preferredName)}
        name="preferredName"
        fullWidth
      />
    </div>
  );
};
